import React from 'react';
import PropTypes from 'prop-types';
import Flexbox from 'flexbox-react';

import ProcessField from 'components/core/fields/ProcessField';
import Constants from 'utils/Constants';
import InfoBoxLabel from 'components/core/InfoBoxLabel';
import RIETextArea from 'components/core/editable/RIETextArea';
import InfoMessages from 'components/core/help/InfoMessages';

export default class ProcessDescriptionField extends ProcessField {

    static propTypes = Object.assign({
        rows: PropTypes.number
    }, ProcessField.propTypes);

    static defaultProps = Object.assign({
        rows: 5
    }, ProcessField.defaultProps);

    render() {
        const process = this.props.process;

        return (
            <Flexbox flexDirection="row" alignItems="flex-start" className={this.props.className}>
                <InfoBoxLabel
                    label="Description"
                    message={InfoMessages.description}
                />
                <RIETextArea
                    value={process.description ? process.description : ''}
                    change={this.onFieldUpdated}
                    fieldPath={['description']}
                    isDisabled={!this.props.hasWritePermissions}
                    processId={this.props.process.name}
                    processErrors={this.props.processErrors}
                    formDisplay={this.props.forceFormDisplay}
                    rows={this.props.rows}
                />
            </Flexbox>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/core/fields/ProcessDescriptionField.js